<p>This side effect causes the flow to return the current work item to the previous level, and reassign the workflow to
  the appropriate state and/or group.
  If the return is to the submitter, please check the box below and specify a timeframe for the Resubmit task to be
  completed.
</p>

<div class="tiny">
  <label class="switch-label inline vertical-align-middle minor-margin-right" for="isResubmit">Return to submitter:</label>
  <input class="no-margin-bottom vertical-align-middle" type="checkbox" [checked]="sideEffect.configuration.isResubmit" id="isResubmit"
    (change)="isResubmitChanged($event.target.checked)" />
  </div>

  @if (sideEffect.configuration.isResubmit) {
    <div class="grid-x">
      <div class="cell small-12">
        Date Based on:
      </div>
      <div class="cell small-12">
        <select [(ngModel)]="sideEffect.configuration.dateType" (ngModelChange)="changeDateType()">
          @for (opt of dateOptions; track opt) {
            <option [value]="opt.id">{{opt.text}}</option>
          }
        </select>
      </div>
      @if (sideEffect.configuration.dateType === 'time') {
        <div class="grid-x full-width">
          <div class="cell small-7">
            <input type="number" [(ngModel)]="sideEffect.configuration.timeFrame" min="0" class="text-align-right" />
          </div>
          <div class="cell small-5 padding-left">
            days after submit.
          </div>
        </div>
      }
      @if (sideEffect.configuration.dateType === 'expression') {
        <div class="cell small-12">
          <rules-editor [type]="sideEffect.configuration.rule.name" [(rule)]="sideEffect.configuration.rule">
          </rules-editor>
        </div>
      }
    </div>
  }